import { useSearchState } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<{
	nOfFilters: number;
}>;

export function useTopicsMobileButton(): Result {
	const state = useSearchState();

	return {
		data: {
			nOfFilters: state.topics.length,
		},
	};
}
